(function($){
	$(document).ready(function(){
		if($('.app-details-page').length > 0)
		{
			var currentActive = $('#desc'),
				currentScreen = $('.screenshot-wrapper img:first-child'),
				currentButton = $('.screenshot-wrapper button:first-child'),
				moving = false,
				waypoints = $('.app-details-section').waypoint({
					handler: function(direction) {
						if(!moving) {
							currentActive.removeClass('active');
							currentActive = $('#'+this.element.id.split('section_')[1]);
							currentActive.addClass('active');
						}
					},
					offset: 100
				});

            var sidebarHeight = $('.pinned').outerHeight(), $contentRow = $('.pinned').closest('.row');
            $contentRow.css({minHeight: sidebarHeight});

            if($('#page-service-details').length <= 0) {

                var sticky = new Waypoint.Sticky({
                    element: $('.pinned')[0]
                });

                var inview = new Waypoint.Inview({
                    element: $('#footer-logo')[0],
                    enter: function (direction) {
                        $('.pinned').fadeOut('fast');
                    },
                    exit: function (direction) {
                        $('.pinned').fadeIn();
                    },
                    exited: function (direction) {
                        $('.pinned').fadeIn();
                    }
                });
            }

			$('.app-details-list a').each(function(index,el){
				var $el = $(el);
				$el.bind('click', function(e){
					e.preventDefault();
					POP.scrollTo($('#section_'+$el.data('target')),false,false,0, function(){
						moving = false;	
					});
					moving = true;

					currentActive.removeClass('active');
					currentActive = $el.closest('li');
					currentActive.addClass('active');
				});
			});

			$('.section-header button').bind('click', function(e){
				POP.scrollTo($('#top'),false,false);
			});
			
			$('.screenshot-wrapper ul li button').each(function(index,el){
				var $el = $(el);

				$el.bind('click', function(e){
					e.preventDefault();
					currentScreen.removeClass('active');
					currentButton.removeClass('active');

					currentScreen = $('.screenshot-wrapper img[data-img="'+$el.data('img')+'"]');
					currentButton = $el;

					currentScreen.addClass('active');
					currentButton.addClass('active');
				});
			});

            $('[data-toggle="tooltip"]').tooltip({container: 'body'});
        }

	});
}(jQuery));
